import { Dropzone_s } from 'components/import-export/import-styles'
import DataTable_s from 'components/table/data-table-styles'
import styled from "styled-components"
import { Colors } from "styles/app-styles"
import { FormError_s, FormSection } from 'styles/form-styles'

export const ImportExport_s = styled.div`
  margin: -30px 0px 0 5px;
  ${Dropzone_s} {
    height: calc(100% - 200px) !important;
    margin-top: 20px;
    width: calc(100% - 120px) !important;
  }
`

export const RdcfExport_s = styled.div`
  > div:first-child {
    background: ${Colors.inputFocus};
    border: 1px solid ${Colors.towerGrey};
    margin: 15px 20px 15px 0;
    padding: 15px;
    display: flex;
    justify-content: space-between;
    > div {
      align-items: center;
      display: flex;
      label { 
        margin-right: 10px;
      }
    }
  }
`

export const ExportType_s = styled.div`
  label {
    color: ${Colors.blackPearl};
    font-weight: 400;
    margin-left: 15px;
    text-transform: uppercase;
  }
  > div.p-listbox {
    margin-top: 10px;
    width: 250px !important;
  }
  > div.p-listbox .p-listbox-item span { font-size: 16px; }
`

export const BiDataExport_s = styled.div`
  > div:first-child {
    background: ${Colors.inputFocus};
    border: 1px solid ${Colors.towerGrey};
    margin: 15px 20px 15px 0;
    padding: 15px;
    display: flex;
    justify-content: space-between;
    > div {
      display: flex;
    }
  }
  > div:last-child {
    display: flex;
  }
  .bi-data-export-input {
    display: flex;
    flex-direction: column;
    margin-right: 15px;
    label { margin-bottom: 10px; }
    &.description {
      width: 350px;
    }
  }
`

export const PropertyTable_s = styled.div`
  margin-left: 20px;
  width: 800px;
  ${DataTable_s}{ margin-top: 10px; }
  tbody > tr > td:nth-child(n+2) { padding-left: 5px; }
  .p-datatable-thead > tr > th.p-filter-column:first-child > div.p-checkbox { display: none; }
  .p-datatable-thead { 
    background: ${Colors.white}; 
    position: absolute;
  }
  tbody.p-datatable-tbody {
    display: block;
    max-height: calc(100vh - 350px);
    overflow: auto;
    padding-top: 65px;
  }
  div.p-paginator {
    width: 800px;
  }
`

// VTS Import
export const DealStages_s = styled.div`
  padding: 5px 15px;
  margin-top: 10px;
  width: 400px;
  button {
    display: block;
    margin: 10px 0;
  }
  ${FormError_s}{
    font-size: 14px;
    margin-left: 15px;
  }
`
export const ImportFrom_s = styled.div`
  background: ${Colors.inputFocus};
  border: 1px solid ${Colors.towerGrey};
  display: flex;
  flex-direction: column;
  margin: 20px 0 5px 0;
  padding: 15px;
  button { 
    margin-top: 15px;
    width: 80px; 
  }
  input {
    height: auto;
    margin: 0 5px 0 7px;
  }
  > label { margin-bottom: 15px; }
`
export const VtsImport_s = styled(FormSection)`
  display: flex;
  flex-direction: column;
  width: calc(100% - 20px);
  label { font-weight: 500; }
`
